import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowLeft } from "lucide-react";

// Trivia palette: warm paper + ink + forest green accent (brown/brick stays for Curios).
export const TV = {
  bg: "bg-[#F4F1EA]",
  card: "bg-white border border-[#E4DED2] rounded-[20px] shadow-[0_12px_30px_-24px_rgba(40,32,20,0.35)]",
  inset: "bg-[#EEE8DD] border border-[#DDD5C7] rounded-[16px]",
  green: "bg-[#2D4A3E] text-white rounded-[20px]",
  greenInset: "bg-[#3E5D50] border border-[#557367] rounded-[16px]",
  pillDark: "bg-[#161514] text-white rounded-full hover:bg-black active:scale-[0.98] transition-[transform,background-color]",
  pillLight: "bg-white text-[#161514] border border-[#DDD5C7] rounded-full hover:bg-[#F7F4EE] active:scale-[0.98] transition-[transform,background-color]",
  pillMint: "bg-[#E5EEE8] text-[#2D4A3E] border border-[#C7D9CE] rounded-full",
  pillBrick: "bg-[#F5E4DF] text-[#9E4535] border border-[#E7C3B9] rounded-full",
  pillTag: "bg-[#EEE8DD] text-[#4A453E] border border-[#DDD5C7] rounded-full",
  ink: "text-[#161514]",
  muted: "text-[#77716A]",
  footer: "bg-[#F8F5EF] border-t border-[#ECE6DB]",
};

export const TvKicker = ({ children, line = true, className = "" }) => (
  <p className={`flex items-center gap-3 tv-caps text-[#57524B] ${className}`}>
    {line && <span className="w-8 h-px bg-[#BDB5A8]" />} {children}
  </p>
);

export const TvHeader = ({ title, subtitle, isMember, back }) => (
  <div className="border-b border-[#DDD5C7] bg-[#F4F1EA]">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
      <Link to={back || "/trivia"} data-testid="tv-header-home" className="flex items-center gap-3 min-w-0 group">
        {back && <ArrowLeft className="w-4 h-4 shrink-0 text-[#57524B] group-hover:text-[#161514] group-hover:-translate-x-0.5 transition-[color,transform]" />}
        <img src="/seal-header-black.png" alt="CurioVault black wax seal" width={40} height={40} data-testid="tv-header-seal"
          className="w-10 h-10 shrink-0 object-contain drop-shadow-sm transition-transform group-hover:-rotate-6" />
        <span className="min-w-0">
          <span className="block font-ui font-bold tracking-[0.16em] text-[#161514] text-xs sm:text-sm uppercase">{title}</span>
          <span className="block font-ui text-xs text-[#77716A] truncate group-hover:text-[#161514] transition-colors">{subtitle}</span>
        </span>
      </Link>
      <Link
        to={isMember ? "/account" : "/club"}
        data-testid="hub-club-link"
        className={`${TV.pillDark} shrink-0 inline-flex items-center gap-1.5 px-4 py-2 font-ui text-[11px] font-semibold tracking-[0.12em] uppercase`}
      >
        <Sparkles className="w-3 h-3" /> {isMember ? "Member" : "Join Club"}
      </Link>
    </div>
  </div>
);
